export default __webpack_public_path__ + "static/media/parent-emails.d908fad8.png";